import Component from '../core/Component'
import { GOOGLE_MAPS_API_KEY } from '../core/config'

export const defaults = {
    zoom: 10,
    lat: '50.088470',
    lng: '14.418742'
}

export default class GoogleMapImage extends Component {
    constructor(element) {
        super(element)

        this.latlng = null

        this.ref = {
            image: null
        }

        const options = this.element.dataset.options

        this.options = {
            ...defaults,
            ...(options ? JSON.parse(options) : {})
        }
    }

    prepare() {
        let url = "https://maps.googleapis.com/maps/api/staticmap?"

        let parameters = {
            center: `center=${this.options.lat},${this.options.lng}`,
            zoom: `&zoom=${this.options.zoom}`,
            size: `&size=580x580`,
            markers: `&markers=color:red%7C${this.options.lat},${this.options.lng}`,
            key: `&key=${GOOGLE_MAPS_API_KEY}`
        }

        this.ref.image.setAttribute('src', url + parameters.center + parameters.zoom + parameters.size + parameters.markers +parameters.key + '&scale=1')
        this.ref.image.setAttribute('srcset', url + parameters.center + parameters.zoom + parameters.size + parameters.markers +parameters.key + '&scale=2 2x')
    }
}
